import { Box } from "@twilio-paste/core/box";
import { Text } from "@twilio-paste/core/text";
import { MediaObject, MediaFigure, MediaBody } from "@twilio-paste/core/media-object";

import { containerStyles, titleStyles } from "./styles/Header.styles";

export const Header = ({ customTitle, logoSrc }: { customTitle?: string; logoSrc?: string }) => {
    return (
        <Box as="header" {...containerStyles}>
            {logoSrc && (
                <MediaObject verticalAlign="center">
                    <MediaFigure spacing="space40">
                        <img src={logoSrc} alt="company logo" />
                    </MediaFigure>
                    <MediaBody>
                        <Text as="h2" {...titleStyles}>
                            {customTitle || "Live Chat"}
                        </Text>
                    </MediaBody>
                </MediaObject>
            )}
            {!logoSrc && (
                <Text as="h2" {...titleStyles}>
                    {customTitle || "Live Chat"}
                </Text>
            )}
        </Box>
    );
};
